import React from 'react';
import { Box, Skeleton, Tooltip, Typography } from '@mui/material';
import { ContentTooltiptStudentDistribution, useStyles } from '../ContentTooltip/ContentTooltip';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';

const StudentDistributionContainer = ({ isLoading, datasets = [], onStudentView }) => {
  const classes = useStyles();


  const levels = datasets?.levels?.sort((a, b) => b.position - a.position) || [];
  return (
    <div className='relative h-full'>
      <Box className={'absolute inset-0 overflow-auto'}>
        <Typography
          color='primary'
          variant='subtitle1'
          className='sticky top-0px left-0px z-20 bg-background h-8 text-center'
        >
          Student Distribution
        </Typography>
        <Table>
          <TableBody>
            {isLoading ? (
              Array(10)
                .fill()
                .map((_, index) => (
                  <TableRow key={`marking-skeleton-${index}`}>
                    <TableCell width={80}>
                      <Typography>
                        <Skeleton width='100%' />
                      </Typography>
                    </TableCell>
                    <TableCell width={230} className='cursor-pointer'>
                      <Typography>
                        <Skeleton width='100%' />
                        <Skeleton width='50%' />
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <div className='flex items-center justify-center py-2'>
                        <Skeleton width='100%' height={40} variant='rectangular' />
                      </div>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <>
                {levels?.map((lvl, index) => {
                  return (
                    <TableRow key={`lvl-${lvl._id}-index-${index}`}>
                      <TableCell width={80}>
                        <Typography className='text-muted-foreground text-center'>{lvl.name}</Typography>
                      </TableCell>
                      <TableCell width={230} className='cursor-pointer'>
                        <Tooltip
                          id={`lvl-${lvl._id}-index-${index}-definition`}
                          title={lvl.definition}
                          placement='top'
                          arrow
                        >
                          <div className='text-overflow-3-lines'>{lvl.definition}</div>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <div className='flex items-center justify-center py-2'>
                          {lvl.marking.map((mark, im) => {
                            const val = parseFloat(mark.value).toFixed(2);
                            return (
                              <Tooltip
                                id={`marking-${lvl._id}-index-${index}-marking-${mark._id}-index-${im}`}
                                key={`marking-${lvl._id}-index-${index}-marking-${mark._id}-index-${im}`}
                                classes={{ tooltip: classes.customWidthStudentDistribution }}
                                title={
                                  <ContentTooltiptStudentDistribution
                                    percentage={`${val}%`}
                                    level={lvl}
                                    marking={{
                                      markingName: mark.name,
                                      markingPrimaryColor: mark.primaryColor,
                                      markingSecondaryColor: mark.secondaryColor
                                    }}
                                    onClick={onStudentView}
                                    students={mark.students || []}
                                  />
                                }
                                arrow
                              >
                                <div
                                  className='hover-outline-muted text-xs flex flex-col items-center justify-center w-full bg-loading2 cursor-pointer overflow-hidden outline-background cursor-pointer'
                                  style={{
                                    height: 40,
                                    width: `${val}%`,
                                    backgroundColor: mark.primaryColor,
                                    color: mark.secondaryColor
                                  }}
                                >
                                  {parseFloat(mark.value).toFixed(0)}%
                                </div>
                              </Tooltip>
                            );
                          })}
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </>
            )}
          </TableBody>
        </Table>
      </Box>
    </div>
  );
};

export default StudentDistributionContainer;
